import { REG_OPTS } from "@/lib/regRange";

export function RegFilter({ value, onChange }) {
  const set = (p) => onChange({ ...value, ...p });
  return (
    <div className="r" style={{ gap: 10, flexWrap: "wrap", alignItems: "center", margin: "0 0 12px" }} data-testid="reg-filter">
      <b style={{ fontSize: 13 }}>Registered</b>
      <div className="seg2" style={{ flexWrap: "wrap" }} data-testid="reg-filter-options">
        {REG_OPTS.map(([k, l]) => <span key={k} className={value.k === k ? "on" : ""} onClick={() => set({ k })} data-testid={`reg-opt-${k}`}>{l}</span>)}
      </div>
      {value.k === "dates" && <div className="r" style={{ gap: 8, flexWrap: "wrap" }}>
        <label className="mu" style={{ fontSize: 13 }}>From <input type="date" className="sel" value={value.f} onChange={(e) => set({ f: e.target.value })} data-testid="reg-from-date" /></label>
        <label className="mu" style={{ fontSize: 13 }}>To <input type="date" className="sel" value={value.t} onChange={(e) => set({ t: e.target.value })} data-testid="reg-to-date" /></label></div>}
      {value.k === "months" && <div className="r" style={{ gap: 8, flexWrap: "wrap" }}>
        <label className="mu" style={{ fontSize: 13 }}>From month <input type="month" className="sel" value={value.fm} onChange={(e) => set({ fm: e.target.value })} data-testid="reg-from-month" /></label>
        <label className="mu" style={{ fontSize: 13 }}>To month <input type="month" className="sel" value={value.tm} onChange={(e) => set({ tm: e.target.value })} data-testid="reg-to-month" /></label></div>}
    </div>
  );
}
